import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-hilfe',
  templateUrl: './hilfe.component.html',
  styleUrls: ['./hilfe.component.css'],
})
export class HilfeComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;
  faArrowLeft = faArrowLeft;

  constructor(private location: Location) {}

  ngOnInit(): void {}

  goBack() {
    this.location.back();
  }
}
